import { Product as Products } from '@infura/packages.api'

export namespace Infura {
  export type ProductType = 'all-products' | Products

  export type Product = {
    name: string
    productType: ProductType
  }

  export enum AUTH_LOGIN_STEP {
    LOGIN = 'login',
    WALLET_LOGIN_MULTI_USER = 'wallet-login-multi-user',
    WALLET_LOGIN_EMAIL_PASSWORD = 'wallet-login-email-password'
  }

  export enum AUTH_LOGIN_METHOD {
    EMAIL_PASSWORD = 'email-password',
    WALLET = 'wallet'
  }
}
